export default (urlParameters) => {
  return {
    footer_ad: true,
    storm_center: true,
    storm_track: true
  }
}